<div class="segment-pills-row">
  <div class="segment-pills" role="tablist">
    @for (command of store.$viewCommands(); track command._id) {
      @let view = command.data;
      @let active = view?._id === store.$viewId();
      <button type="button" class="segment-pill" role="tab" [class.active]="active" [attr.aria-selected]="active" (click)="onSelect(view)">
        <span class="text">{{ command.label }}</span>
      </button>
    }
  </div>
</div>
